import { Button, Col, Drawer as DrawerAntd, Row, Space, Typography } from 'antd';
import styled from 'styled-components';
import useTranslations from '../../hooks/useTranslations';

const { Text } = Typography;

const DrawerStyled = styled(DrawerAntd)`
    z-index: 999 !important;
    .ant-drawer-content-wrapper {
        box-shadow: none !important;
        max-width: 430px;
        margin: auto;
    }

    .ant-drawer-content {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;

        .ant-drawer-body {
            padding: 8px 16px;
            overflow-y: auto;
            .ant-select-dropdown {
                box-shadow: unset !important;
                .ant-select-item {
                    text-align: center;
                }
            }
        }

        .ant-drawer-header {
            border-bottom: unset;
            padding-bottom: 0px;

            .ant-drawer-title {
                font-weight: bold;
                display: flex;
                justify-content: space-between;
            }
        }
        .ant-drawer-footer {
            .ant-space {
                width: 100%;
                justify-content: center;

                .ant-btn {
                    min-width: 116px;
                }
            }
        }
    }

    .ant-drawer-mask {
        backdrop-filter: blur(6px);

        &:before {
            content: '';
            position: absolute;
            top: -1px;
            bottom: -1px;
            left: -1px;
            right: -1px;
            opacity: 0.5;
            overflow: hidden;
        }
    }
`;

const DrawerPickerStyled = styled(Drawer)`
    .ant-select-dropdown {
        box-shadow: none;
    }

    .ant-drawer-content-wrapper {
        height: 500px !important;
    }

    .ant-drawer-header {
        z-index: 99999;
    }
    .ant-drawer-footer {
        .ant-space {
            width: 100%;
            justify-content: center;

            .ant-btn {
                min-width: 116px;
            }
        }
    }
`;

export default function Drawer({ children, title, ...props }) {
    return (
        <DrawerStyled title={title} closable={false} destroyOnClose placement="bottom" zIndex={999999999999} {...props}>
            {children}
        </DrawerStyled>
    );
}

function DrawerPicker({ children, onOk, onClose, ...props }) {
    const { t } = useTranslations();
    const textDone = t('Done', 'Done');
    const customTitle = (
        <Row wrap={false} justify="space-between" align="middle" style={{ width: '100%' }}>
            <Col flex="auto">
                <Text>{props.title}</Text>
            </Col>
            {props?.extraTitle && <Col flex="none">{props?.extraTitle}</Col>}
        </Row>
    );

    return (
        <DrawerPickerStyled
            onClose={onClose}
            placement="bottom"
            height={460}
            maskClosable
            bodyStyle={{ overflow: 'auto' }}
            maskStyle={{ overflow: 'hidden' }}
            footer={
                <Space>
                    <Button type="primary" onClick={onOk}>
                        {textDone}
                    </Button>
                </Space>
            }
            {...props}
            title={customTitle}
        >
            {children}
        </DrawerPickerStyled>
    );
}

Drawer.Picker = DrawerPicker;
